import { render, staticRenderFns } from "./IconFileUpload.vue?vue&type=template&id=35c09f96&scoped=true&"
import script from "./IconFileUpload.vue?vue&type=script&lang=js&"
export * from "./IconFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c09f96",
  null
  
)

export default component.exports